export enum CompanyIdentifier {
  EIN = "ein",
  COMPANY_NAME = "company_name",
}
